import { OrderBookingData } from 'entities/orders/model/types';
import { isArrayEquals } from 'shared/lib/core';

export const compareBookingDatas = (
	bookingDataInitial: OrderBookingData | null,
	bookingData: OrderBookingData,
) => {
	return (
		bookingDataInitial?.dt_start === bookingData.dt_start &&
		bookingDataInitial.participants_count === bookingData.participants_count &&
		bookingDataInitial.duration === bookingData.duration &&
		bookingDataInitial.hold_resources === bookingData.hold_resources &&
		bookingDataInitial.notes === bookingData.notes &&
		(bookingDataInitial.prepayment_amount || '') === bookingData.prepayment_amount &&
		bookingDataInitial.person?.name === bookingData.person?.name &&
		isArrayEquals(bookingDataInitial.tags, bookingData.tags)
	);
};
